export default __webpack_public_path__ + "static/media/badge_support.2a73766b.svg";